import React from 'react';
import { Handle, Position } from 'reactflow';
import { CustomSparkInputOutputValuesNode } from './Custom';
import { SparkStepNodeProps } from './SparkStepNode';

export default React.memo(({ data }: SparkStepNodeProps) => {
  return (
    <>
      <Handle
        type='target'
        position={Position.Top}
        style={{ background: '#555', visibility: 'hidden' }}
      />
      <CustomSparkInputOutputValuesNode data={data} />
      <Handle
        type='source'
        position={Position.Bottom}
        style={{ background: '#555', visibility: 'hidden', width: '20px' }}
      />
    </>
  );
});
